import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cx } from './cx';
import { controlBase } from './Input';
import { useFieldControl } from './Field';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, id, rows = 4, ...rest },
  ref,
) {
  const field = useFieldControl(id);
  return <textarea ref={ref} rows={rows} {...field} className={cx(controlBase, 'resize-y', className)} {...rest} />;
});
